<template>
  <view-edit-panel
    class="cooling-stages"
    v-model="transformerCoolingStage"
    :loading="loading"
    :disable-save="!!invalidFields.length"
    @changing="save"
  >
    <b-container
      slot-scope="data"
      fluid
    >
      <template v-if="!loading">
        <cooling-stages-form
          v-model="data.item"
          :saving="data.saving"
          :editing="data.editing"
          :invalid-fields.sync="invalidFields"
          @change-cooling-object="setValueOnCoolingObject($event, data)"
        />
      </template>
      <b-row
        v-else
        class="cooling-stages__loader"
        align-h="center"
        align-v="center"
      >
        <s-loader size="lg" />
      </b-row>
    </b-container>
  </view-edit-panel>
</template>

<script>
import ViewEditPanel from '@/components/ViewEditPanel';
import loadingMixin from '@/services/loadingMixin';
import CoolingStageService from '@/domain/services/installation/assetInfo/coolingStages';
import CoolingStagesForm from '@/domain/components/installation/assetInformation/transformers/coolingStages/CoolingStagesForm';
import TreeviewHeaderSubtitleMixin from '@/components/treeview/treeviewHeaderSubtitleMixin';

export default {
  name: 'CoolingStages',
  components: { ViewEditPanel, CoolingStagesForm },
  mixins: [
    loadingMixin,
    TreeviewHeaderSubtitleMixin,
  ],
  data: () => ({
    invalidFields: [],
    transformerCoolingStage: {
      coolingStagesAmount: 0,
      tertiaryWinding: false,
      monitoredWindingAmount: 0,
      coolingStages: [],
    },
  }),
  created() {
    this.getCoolingStages();
    this.updateHeaderTitle(this.$t('asset-information.menu.cooling-stages'));
  },
  methods: {
    fillCoolingStages(transformerCoolingStages) {
      const { coolingStages, coolingStagesAmount } = transformerCoolingStages;
      const startIndex = 0;
      const endIndex = coolingStagesAmount;
      for (let stageIndex = startIndex; stageIndex <= endIndex; stageIndex += 1) {
        const filledCoolingStage = coolingStages.some(x => x.stageNumber === stageIndex);
        if (!filledCoolingStage) {
          coolingStages.push({ stageNumber: stageIndex });
        }
      }
      return coolingStages.sort((a, b) => ((a.stageNumber > b.stageNumber) ? 1 : -1));
    },
    sliceCoolingStages(coolingStages, coolingStagesAmount) {
      return coolingStages.filter(stage => stage.stageNumber <= coolingStagesAmount);
    },
    getStagesByCoolingAmount(transformerCoolingStages) {
      const { coolingStages, coolingStagesAmount } = transformerCoolingStages;
      const fixedStageCount = 1;
      const dynamicStagesCount = coolingStages.length - fixedStageCount;
      if (coolingStagesAmount > dynamicStagesCount) {
        return this.fillCoolingStages(transformerCoolingStages);
      }
      return this.sliceCoolingStages(coolingStages, coolingStagesAmount);
    },
    save({ newValue, accept, reject }) {
      const { assetId } = this.$route.params;
      const coolingStages = this.getStagesByCoolingAmount(newValue);
      this.startLoading();
      CoolingStageService.putCoolingStages(assetId, { coolingStages })
        .then(() => {
          this.getCoolingStages();
          accept();
        })
        .catch(reject)
        .finally(() => { this.endLoading(); });
    },
    getCoolingStages() {
      const { assetId } = this.$route.params;
      this.startLoading();
      CoolingStageService.getCoolingStages(assetId)
        .then((response) => {
          this.transformerCoolingStage = response;
        })
        .finally(() => { this.endLoading(); });
    },
    getCoolingStageByStageFromData(stage, data) {
      const stages = data.item.coolingStages || [];
      return stages.find(item => item.stageNumber === stage);
    },
    setValueOnCoolingObject({ stage, field, value }, data) {
      let stageByNumber = this.getCoolingStageByStageFromData(stage, data);
      if (!stageByNumber) {
        stageByNumber = { stageNumber: stage };
        data.item.coolingStages.push(stageByNumber);
      }
      stageByNumber[field] = value;
    },
  },
};

</script>

<style lang="sass" scoped>
  .cooling-stages
    &__title
      font-size: 2em
    &__loader
      height: 500px
</style>
